import { makeObservable } from 'mobx';
import { Filtro } from './Filtro';
import SituacaoSustentacaoOralEletronica, {
    SITUACAO_SUSTENTACAO_ORAL_ELETRONICA
} from '@/dominio/SituacaoSustentacaoOralEletronica';

export default class FiltroSituacaoSustentacaoOralEletronica extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    tamanhoIcone = '24px';
    opacidadeIcone = '0.7';
    paddingIcone = '2px';

    get label() {
        return 'Marcação de situação da sustentação oral eletrônica de advogado';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        const situacoes = [];

        if (this.hasSustentacaoOralEletronicaSemValidacao(registro)) {
            situacoes.push(SITUACAO_SUSTENTACAO_ORAL_ELETRONICA.SEM_VALIDACAO.id);
        }

        if (this.hasSustentacaoOralEletronicaAprovada(registro)) {
            situacoes.push(SITUACAO_SUSTENTACAO_ORAL_ELETRONICA.APROVADA.id);
        }

        if (this.hasSustentacaoOralEletronicaReprovada(registro)) {
            situacoes.push(SITUACAO_SUSTENTACAO_ORAL_ELETRONICA.REPROVADA.id);
        }

        return situacoes;
    }

    verificaSeExisteSustentacaoOralEletronicaNaSituacao(registro, valorSituacao) {
        let existeSustentacaoOralEletronicaNaSituacao = false;

        registro?.pedidoSustentacaoOral?.pedidosDetalhados?.forEach((pedido) => {
            if (existeSustentacaoOralEletronicaNaSituacao) {
                return;
            }

            pedido?.advogados?.forEach((advogado) => {
                if (existeSustentacaoOralEletronicaNaSituacao) {
                    return;
                }

                advogado?.documentosSustentacao?.forEach((documentoSustentacao) => {
                    if (String(documentoSustentacao?.validado) === valorSituacao) {
                        existeSustentacaoOralEletronicaNaSituacao = true;
                    }
                });
            });
        });
        return existeSustentacaoOralEletronicaNaSituacao;
    }

    hasSustentacaoOralEletronicaReprovada(registro) {
        return this.verificaSeExisteSustentacaoOralEletronicaNaSituacao(registro, 'false');
    }

    hasSustentacaoOralEletronicaAprovada(registro) {
        return this.verificaSeExisteSustentacaoOralEletronicaNaSituacao(registro, 'true');
    }

    hasSustentacaoOralEletronicaSemValidacao(registro) {
        return this.verificaSeExisteSustentacaoOralEletronicaNaSituacao(registro, 'undefined');
    }

    getDescricao(valor) {
        return SituacaoSustentacaoOralEletronica.getDescricao(valor);
    }
}
